import React, { useState, useEffect } from 'react';
import { X, Minus, Plus, MessageCircle } from 'lucide-react';
import { getCartist, updateCart, deleteTransaction, generateexcel, importexcel, clearcart } from '../../redux/services/productService';
import Swal from 'sweetalert2';
import { FileSpreadsheet, Trash2, UploadCloud } from "lucide-react";
import Tooltip from '@mui/material/Tooltip';

const SlideCart = ({ onClose, onViewCart, onCheckout, onCartUpdate }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
    const [userId, setUserId] = useState(null);
    const [typingTimeout, setTypingTimeout] = useState(null);

    

    
useEffect(() => {
  const storedData = localStorage.getItem('userData');

  if (storedData) {
    let parsedData = JSON.parse(storedData);

    // Check if parsedData is still a string (double stringified case)
    if (typeof parsedData === 'string') {
      parsedData = JSON.parse(parsedData);
    }

    if (parsedData && parsedData[0]?.UserId) {
      setUserId(parsedData[0].UserId);
    }
  }
}, []);

  useEffect(() => {
    // Always fetch fresh cart data from API, similar to Cart.jsx
    fetchCartItems();
  }, []);

  const fetchCartItems = async () => {
    try {
      const res = await getCartist();
      const parsedData = JSON.parse(res.result);
   
      if(res?.status =="Success"){
        if (parsedData?.Data) {
        const mappedItems = parsedData?.Data?.map((item, index) => ({
          id: item.TransId || index,
          transId: item.TransId,
          product:item.Product_Id,
          name: item.Product_Name || "Unnamed Product",
          price: item.Rate || 0,
          quantity: item.Quantity || 1,
          image: item.Image,
          StockQty:item.StockQty || 0
        }));
        
        setItems(mappedItems);
      }
      }
      else{
        setItems([])
      }
      
    } catch (error) {
      console.error("Error fetching cart:", error);
      setItems([])
    } finally {
      setLoading(false);
    }
  };

  const updateQuantity = async (id, newQuantity) => {
   const item = items.find(i => i.id === id);
  if (!item) return;

  newQuantity = Number(newQuantity);

  if (newQuantity > item.StockQty) {
   
     Swal.fire({
                  icon: "error",
                  //title: "Error",
                  text: `Only ${item.StockQty} available in stock.`,
                });
                 return; 
  }

  if (newQuantity < 1) return;

  // Update UI
  setItems(items.map(i =>
    i.id === id ? { ...i, quantity: newQuantity } : i
  ));


    // Update cart via API
    try {
      const payload = {
        transId: item.transId || 0,
        date: new Date().toISOString().split("T")[0],
        customer: userId, // You might need to get this from context/state
        warehouse: 2,
        remarks: "",
        discountType: 0,
        discountCouponRef: "",
        discountRef: "",
        sampleRequestedBy: 0,
        product: item.product,
        qty: newQuantity,
        rate: item.price,
        unit: 1,
        totalRate: item.price * newQuantity,
        addCharges: 0,
        discount: 0,
        discountAmt: 0,
        discountRemarks: "",
        be: 0,
      };
      await updateCart(payload);

      // Notify parent component of cart update
      if (onCartUpdate) {
        onCartUpdate();
        fetchCartItems()
      }
    } catch (error) {
      console.error("Error updating cart:", error);
      // Revert local state on error
      setItems(items.map(item =>
        item.id === id
          ? { ...item, quantity: item.quantity  }
          : item
      ));
    }
  };

  

  const removeItem = async (id) => {
    const item = items.find(item => item.id === id);
    if (!item) return;

    // Update local state immediately
    setItems(items.filter(item => item.id !== id));

    // Remove from cart via API
    try {
      const payload = {
        docType: 3,
        be: 0,
        idCollection: [{ id }]
      };
      await deleteTransaction(payload);

      // Notify parent component of cart update
      if (onCartUpdate) {
        onCartUpdate();
        fetchCartItems()
      }
    } catch (error) {
      console.error("Error removing item:", error);
      // Revert local state on error
      fetchCartItems(); // Refetch to restore state
    }
  };

  const calculateSubtotal = () => {
    return items.reduce((total, item) => total + (item?.price * item?.quantity), 0);
  };
const handleQuantityTyping = (id, value) => {
  // Allow empty while typing
  if (value === "") {
    setItems(items.map(i =>
      i.id === id ? { ...i, quantity: "" } : i
    ));
    if (typingTimeout) clearTimeout(typingTimeout);
    return;
  }

  // Block non-numeric input
  if (!/^[0-9]+$/.test(value)) return;

  // Remove leading zeros
  const cleaned = value.replace(/^0+/, "") || "0";

  // Update UI instantly
  setItems(items.map(i =>
    i.id === id ? { ...i, quantity: cleaned } : i
  ));

  // CLEAR old timer
  if (typingTimeout) clearTimeout(typingTimeout);

  // ⏱ START 2-second debounce
  const timer = setTimeout(() => {
    const item = items.find(i => i.id === id);
    if (!item) return;

    const qty = Number(cleaned);

    if (qty < 1) return;

    if (qty > item.StockQty) {
      // Reset to max allowed
      Swal.fire({
                  icon: "error",
                  //title: "Error",
                  text: `Only ${item.StockQty} available in stock.`,
                });
      //updateQuantity(id, item.StockQty);
      return;
    }

    // 🔥 Finally call updateQuantity (ID, FINAL VALUE)
    updateQuantity(id, qty);

  }, 2000);

  setTypingTimeout(timer);
};

const handleExportExcel = async () => {
  try {
    const response = await generateexcel({BE:1}); // API returning file blob
    if(response.status =="Success"){
     const fileUrl = JSON.parse(response.result).replace(/\\/g, "/"); // fix slashes

      const a = document.createElement("a");
      a.href = fileUrl;
      a.target = "_blank"; // <-- OPEN IN NEW TAB
      a.download = ""; // let server filename be used
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Swal.fire("Success", "Excel exported successfully!", "success");

    }
    
  } catch (error) {
    Swal.fire("Error", "Failed to export Excel", "error");
    console.error(error);
  }
};
const handleImportExcel = async () => {
  const { value: file } = await Swal.fire({
    title: "Item Import",
    html: `
      <input type="file" id="excelFile" accept=".xlsx,.xls" class="excel-upload-input">
    `,
    confirmButtonText: "Upload",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    reverseButtons: true,
    customClass: {
      confirmButton: "next-btn2", // your custom button style
    },
    didOpen: () => {
      // Apply inline styles to input
      const input = document.getElementById("excelFile");
      if (input) {
        input.style.maxWidth = "230px";
        input.style.width = "230px";
        input.style.height = "35px";
        input.style.padding = "6px";
        input.style.border = "1px solid #ccc";
        input.style.borderRadius = "6px";
        input.style.fontSize = "14px";
      }
      const titleEl = document.querySelector('.swal2-title');
  if (titleEl) {
    titleEl.style.fontSize = '20px';  // change size here
    titleEl.style.fontWeight = '600';
  }
  const confirmBtn = document.querySelector('.swal2-confirm.next-btn2');


/* For smaller screens */
if (window.innerWidth < 490) {
  if (confirmBtn) {
    confirmBtn.style.width = "100px"; // reduce width
    confirmBtn.style.fontSize = "13px";
    confirmBtn.style.maxHeight  = "40px"
  }
}

    },
    preConfirm: () => {
      const input = document.getElementById("excelFile");
      if (!input.files.length) {
        Swal.showValidationMessage("Please select an Excel file");
        return false;
      }
      return input.files[0];
    },
  });

  if (file) {
    const formData = new FormData();
    formData.append("fileContent", file);

    try {
      const res = await importexcel(formData);
      if (res?.status == "Success" && res?.result == "1") {
        Swal.fire("Success", "Excel imported successfully!", "success");
        fetchCartItems();
        onCartUpdate()
        
      }
      
    } catch (e) {
      if(e?.response?.data?.status =="Failure"){
              Swal.fire("", e?.response?.data?.message, "error");
            }
            else{
              Swal.fire("", "Failed to import file", "error");
            }
    }
  }
};
const handleRemoveSelected = async () => {
  const confirm = await Swal.fire({
    text: `You are about to remove all items.`,
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Remove",
    reverseButtons: true,
    customClass: {
      confirmButton: "next-btn2",
    },
    didOpen: () => {
      const title = document.querySelector(".swal2-title");
      const text = document.querySelector(".swal2-html-container");
      const confirmBtn = document.querySelector(".swal2-confirm.next-btn2");
      const cancelBtn = document.querySelector(".swal2-cancel");

      // Title Style
      if (title) {
        title.style.fontSize = "20px";
        title.style.fontWeight = "600";
      }

      // Text Style
      if (text) {
        text.style.fontSize = "14px";
      }

      // Confirm Button Style (same as Import Excel)
      if (confirmBtn) {
        confirmBtn.style.fontSize = "14px";
        confirmBtn.style.padding = "6px 18px";
        confirmBtn.style.borderRadius = "6px";
        confirmBtn.style.height = "40px";
      }

      // Cancel Button Style
      if (cancelBtn) {
        cancelBtn.style.fontSize = "14px";
        cancelBtn.style.padding = "6px 18px";
        cancelBtn.style.borderRadius = "6px";
        cancelBtn.style.height = "40px";
      }

      // 🔥 Small Screen Adjustment (same logic as import popup)
      if (window.innerWidth < 490) {
        if (confirmBtn) {
          confirmBtn.style.width = "100px";
          confirmBtn.style.fontSize = "13px";
          confirmBtn.style.maxHeight = "40px";
        }
        if (cancelBtn) {
          cancelBtn.style.width = "100px";
          cancelBtn.style.fontSize = "13px";
          cancelBtn.style.maxHeight = "40px";
        }
      }
    }
  });

  if (!confirm.isConfirmed) return;

  try {
    const payload = { BE: 1 };
    const res = await clearcart(payload);

    if (res?.status === "Success") {
      Swal.fire({
        title: "Deleted!",
        text: "All items removed.",
        icon: "success",
        didOpen: () => {
          const title = document.querySelector(".swal2-title");
          const text = document.querySelector(".swal2-html-container");

          if (title) title.style.fontSize = "20px";
          if (text) text.style.fontSize = "14px";
        }
      });

      fetchCartItems();
      onCartUpdate()
    }
  } catch (error) {
    console.error("Delete failed", error);

    Swal.fire({
      title: "Error",
      text: "Failed to delete items",
      icon: "error",
      didOpen: () => {
        const title = document.querySelector(".swal2-title");
        const text = document.querySelector(".swal2-html-container");

        if (title) title.style.fontSize = "20px";
        if (text) text.style.fontSize = "14px";
      }
    });
  }
};



  return (
    <div className="cart-container">
      {/* Header */}
      <div className="cart-header">
        <h2>SHOPPING CART</h2>
        <button className="close-btn" onClick={onClose}>
          <X size={20} />
          <span>CLOSE</span>
        </button>
      </div>
      <div style={{ display: "flex", gap: "10px", alignItems: "center",marginTop:"2px"}}>

    {/* EXPORT EXCEL */}
    <Tooltip title="Export Excel" arrow>
   <button className="icon-btn" onClick={handleExportExcel}>
  <FileSpreadsheet size={26} stroke="#ff5722" />  {/* Excel Green */}
</button>
</Tooltip>
<Tooltip title="Import Excel" arrow>
<button className="icon-btn" onClick={handleImportExcel}>
  <UploadCloud size={26} stroke="#ff5722" />
</button>
</Tooltip>
{items?.length>0?
<Tooltip title="Clear Cart" arrow>
<button className="icon-btn" onClick={handleRemoveSelected}>
  <Trash2 size={26} stroke="#ff5722" />
</button>
</Tooltip>
:null}


    

  </div>

      {/* Cart Items */}
      <div className="cart-items">
        {loading ? (
          <div className="loading">Loading cart...</div>
        ) : items.length === 0 ? (
          <div className="empty-cart">Your cart is empty</div>
        ) : (
          items.map((item) => (
            <div key={item.id} className="cart-item">
              <div className="item-image">
                 <img  className="cart-image" src={item.image} />
              </div>

              <div className="item-details">
                <div className="item-header">
                  <h3>{item.name}</h3>
                  <button
                    className="remove-btn"
                    onClick={() => removeItem(item.id)}
                  >
                    <X size={16} />
                  </button>
                </div>
                <div className="available-qty" style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                  Available Quantity: {new Intl.NumberFormat("en-US").format(item.StockQty)}
                </div>
                <div className="quantity-controls">
                  <button
                    className="qty-btn"
                    onClick={() => updateQuantity(item.id, Number(item.quantity) - 1)}

                  >
                    <Minus size={16} />
                  </button>
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="qty-input"
                    value={item.quantity}
                    onChange={(e) => handleQuantityTyping(item.id, e.target.value)}
                  />
                  <button
                    className="qty-btn"
                    disabled={item.quantity >= item.StockQty}
                    onClick={() => updateQuantity(item.id, Number(item.quantity) + 1)}

                  >
                    <Plus size={16} />
                  </button>
                </div>

                <div className="item-price">
                  {item.quantity} × {(item?.price ??0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Chat with us button */}
      {/* <div className="chat-button">
        <MessageCircle size={24} fill="white" color="white" />
        <span>Chat with us</span>
      </div> */}

      {/* Footer */}
      <div className="cart-footer">
        <div className="subtotal">
          <span>SUBTOTAL:</span>
          <span className="subtotal-amount">
            {calculateSubtotal().toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED
          </span>
        </div>

        <button className="view-cart-btn" onClick={onViewCart}>VIEW CART</button>
        {/* <button className="checkout-btn" onClick={onCheckout}>CHECKOUT</button> */}
      </div>

      <style jsx>{`
        .cart-container {
           width: 340px;
           height: 85vh;
           background: white;
           border: 2px solid #e0e0e0;
           border-radius: 8px;
           display: flex;
           flex-direction: column;
           font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
           position: relative;
           animation: slideIn 0.3s ease-out;
         }
        @media (max-width: 400px) {
            .cart-container {
              width: 280px;      /* full width with padding */
              border-radius: 0; /* optional: removes side gaps */
            }
          }

          @media (max-width: 320px) {
            .cart-container {
              width: 280px;     /* ultra-small devices */
            }
          }
         @keyframes slideIn {
           from {
             transform: translateX(100%);
             opacity: 0;
           }
           to {
             transform: translateX(0);
             opacity: 1;
           }
         }

         .cart-header {
           display: flex;
           justify-content: space-between;
           align-items: center;
           padding: 20px;
           border-bottom: 1px solid #e0e0e0;
         }

         .cart-header h2 {
           margin: 0;
           font-size: 16px;
           font-weight: 600;
           letter-spacing: 0.5px;
         }

         .close-btn {
           display: flex;
           align-items: center;
           gap: 4px;
           background: none;
           border: none;
           cursor: pointer;
           font-size: 14px;
           color: #333;
         }

         .close-btn:hover {
           color: #666;
         }

         .cart-items {
           flex: 1;
           overflow-y: auto;
           padding: 16px;
           scrollbar-width:thin
         }

         .cart-item {
           display: flex;
           gap: 12px;
           padding: 16px 0;
           border-bottom: 1px solid #f0f0f0;
         }

         .item-image {
           width: 60px;
           height: 60px;
           background: #f5f5f5;
           border-radius: 8px;
           display: flex;
           align-items: center;
           justify-content: center;
           flex-shrink: 0;
         }

         .image-placeholder {
           font-size: 32px;
           display:none;
         }

         .item-details {
           flex: 1;
           display: flex;
           flex-direction: column;
           gap: 8px;
         }

         .item-header {
           display: flex;
           justify-content: space-between;
           align-items: flex-start;
         }

         .item-header h3 {
           margin: 0;
           font-size: 14px;
           font-weight: 500;
           color: #333;
           line-height: 1.4;
           flex: 1;
           word-break: break-word;
         }

         .remove-btn {
           background: none;
           border: none;
           cursor: pointer;
           padding: 0;
           color: #999;
           margin-left: 8px;
         }

         .remove-btn:hover {
           color: #333;
         }

         .quantity-controls {
           display: flex;
           align-items: center;
           gap: 12px;
           width: fit-content;
         }

         .qty-btn {
           width: 28px;
           height: 28px;
           border: 1px solid #e0e0e0;
           border-radius: 50%;
           background: white;
           cursor: pointer;
           display: flex;
           align-items: center;
           justify-content: center;
           color: #666;
         }

         .qty-btn:hover {
           background: #f5f5f5;
           border-color: #ccc;
         }

         .quantity {
           font-size: 14px;
           font-weight: 500;
           min-width: 20px;
           text-align: center;
         }

         .item-price {
           font-size: 13px;
           color: #ff5722;
           font-weight: 500;
         }

         .chat-button {
           position: absolute;
           right: 0;
           top: 50%;
           transform: translateY(-50%);
           background: #ff5722;
           color: white;
           padding: 12px 8px;
           border-radius: 24px 0 0 24px;
           cursor: pointer;
           writing-mode: vertical-rl;
           text-orientation: mixed;
           font-size: 12px;
           font-weight: 600;
           letter-spacing: 0.5px;
           display: flex;
           align-items: center;
           gap: 8px;
           box-shadow: -2px 2px 8px rgba(0, 0, 0, 0.1);
         }

         .chat-button:hover {
           background: #f4511e;
         }

         .cart-footer {
           padding: 16px;
           border-top: 1px solid #e0e0e0;
           background: white;
         }

         .subtotal {
           display: flex;
           justify-content: space-between;
           align-items: center;
           margin-bottom: 16px;
           font-weight: 600;
         }

         .subtotal span:first-child {
           font-size: 14px;
           color: #333;
         }

         .subtotal-amount {
           font-size: 18px;
           color: #ff5722;
         }

         .view-cart-btn,
         .checkout-btn {
           width: 100%;
           padding: 14px;
           border: none;
           border-radius: 30px;
           font-weight: 600;
           font-size: 14px;
           letter-spacing: 0.5px;
           cursor: pointer;
           margin-bottom: 8px;
         }

         .view-cart-btn {
           background: #ff5722;
           color: white;
         }

         .view-cart-btn:hover {
           background: #f4511e;
         }

         .checkout-btn {
           background: #e64a19;
           color: white;
           margin-bottom: 0;
         }

         .checkout-btn:hover {
           background: #d84315;
         }
       `}</style>
    </div>
  );
};
export default SlideCart;